import React from "react";
import { Icon } from "./Icon";
export const IconChevronRight = (props) => (
  <Icon {...props}>
    <path d="M9 18l6-6-6-6" />
  </Icon>
);
